/** Shared authoring constants, verbatim from the prototype's landingAurora.ts. */
export const LINE_SPACING = 1 + (Math.PI * 2 - 1) * 0.42;
export const REVEAL_SPACING = 1 + (Math.PI * 2 - 1) * 0.58;
export const VERTICAL_ROTATION = -87.48;
export const PAPER = "#FFFFFF";
export const OPEN_TWIST_RETENTION = 0.9;
export const OPEN_FAN_SPREAD = 0.03;
export const MOBILE_OPEN_FAN_SPREAD = 0.012;
export const OPEN_TWIST_SPREAD = 0.068;
export const MOBILE_OPEN_TWIST_SPREAD = 0.04;
export const OPEN_HORIZONTAL_STRETCH = 1.55;
export const MOBILE_OPEN_HORIZONTAL_STRETCH = 1.3;
export const LANDING_CURVE_DISPLACEMENT_SCALE = 0.35;
export const LANDING_CURVE_FAN_SPREAD = 0.0225;
export const LANDING_MOBILE_CURVE_FAN_SPREAD = 0.009;
export const LANDING_CURVE_TWIST_SPREAD = 0.051;
export const LANDING_MOBILE_CURVE_TWIST_SPREAD = 0.03;
export const LANDING_CURVE_HORIZONTAL_STRETCH = 1.1;
export const LANDING_MOBILE_CURVE_HORIZONTAL_STRETCH = 1.05;
export const OPEN_TURBULENCE = 0.28;
export const OPEN_UNRAVEL = 1;
export const LANDING_HERO_ZOOM = 0.8;
export const LANDING_ENDCAP_ZOOM = 0.5;
export const LANDING_MOBILE_HERO_ZOOM = 0.416;
export const LANDING_MOBILE_LINE_EXTENT = 0.66;
export const LANDING_VERTICAL_WIDTH_SCALE = 0.8;
export const MATCHED_IDLE_SPEED = 0.7;
export const OUR_STORY_IDLE_SPEED = 0.8;
/**
 * Top-anchored scene height shared by every ribbon unless a preset opts into a
 * different authored frame. A shorter viewport crops this frame instead of
 * compressing the ribbon geometry to fit.
 */
export const DEFAULT_RIBBON_FRAMING_HEIGHT = {
    desktop: 1600,
    mobile: 1300,
};
/** Scroll-point vocabulary shared by every role → timeline mapping. */
export const STANDARD_START = { target: "top", viewport: 1 };
export const STANDARD_END = { target: "center", viewport: 0.5 };
export const CHAPTER_ENTRY_START = { target: "top", viewport: 0.8 };
export const CHAPTER_ENTRY_END = { target: "top", viewport: 0.3 };
export const CHAPTER_MEDIA_START = { target: "center", viewport: 0.8 };
export const CHAPTER_MEDIA_END = { target: "center", viewport: 0.25 };
export const FINAL_CHAPTER_MEDIA_END = { target: "center", viewport: 0.5 };
/** The two-state presets settle from where the block ABOVE the settle block begins. */
export const PREVIOUS_BLOCK_TOP = {
    anchor: "previous-block",
    target: "top",
    viewport: 0,
};
//# sourceMappingURL=shared.js.map